import { HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ShellStore } from '@partners/state';
import { HTTP_CONTEXT, IHttpContext } from '../../http';

@Injectable({
  providedIn: 'root'
})
export class MockService {
  private _shellStore = inject(ShellStore);

  constructor() {}

  /**
   * @description
   * add a custom header(s) to an http request to allow passing key values of the bll state to
   * the mock server api, this gives us the option to customize the mock response in the server
   *
   * @param request the http request to add mock header to its headers collection
   * @returns an http request, clone of original with added mock headers
   */
  attachMockArgs(request: HttpRequest<unknown>): HttpRequest<unknown> {
    /** check for request's custom context */
    const httpContext: IHttpContext = request.context.get(HTTP_CONTEXT);

    const { mock } = httpContext;
    const { processId$$ } = this._shellStore;

    /** add custom context to default context params */
    mock.args = {
      ...mock.args,
      ...{
        processId: processId$$()
      }
    };

    const { args } = mock;

    /** add the custom params mock header to the request's headers collection */
    const headers = request.headers.set('context', JSON.stringify(args));

    return request.clone({ headers });
  }
}
